module.exports = __webpack_public_path__ + "static/media/windows.947e6036.png";